import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from "@angular/core";

import { SelectedLocation } from "@hermes/fragments/places-search-bar";
import { ShopLocatorFacade } from "@hermes/states/shop-locator";

@Component({
    selector: "h-shop-locator-search-location",
    templateUrl: "./shop-locator-search-location.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ShopLocatorSearchLocationComponent {
    /**
     * Event fired when the geolocation button is selected
     */
    @Output()
    public geolocationButtonSelected = new EventEmitter<string>();

    @Input()
    public isWorldwideResearch = false;

    constructor(public shopLocatorFacade: ShopLocatorFacade) {}

    @HostListener("click")
    public onClick() {
        this.shopLocatorFacade.unsetHoveredShop();
    }

    public locationSelected(selectedLocation: SelectedLocation): void {
        this.shopLocatorFacade.setSelectedLocation(
            selectedLocation.address,
            selectedLocation.coordinates,
            selectedLocation.isCountry,
            selectedLocation.bounds,
        );
    }
}
